import { Drawer, message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import close from "./../../../../assets/images/close.svg";
import { cancelAppointment } from "../../service";
import { getLocalStorage } from "../../../../utils/localStorage";
import { JWT_TOKEN } from "../../../symptomCollector/utils/constants";
import { calculateAge, trackEvent } from "../../../../utils/helper";
import dayjs from "dayjs";

const CancelConfirmation = ({ show, closePopup, appointmentData }: any) => {
  const { state } = useLocation();
  const location = useLocation();

  const navigate = useNavigate();
  const appointmentDetails = appointmentData || state || {};

  const handleCancelAppointment = async () => {
    const res = await cancelAppointment(appointmentDetails);
    if (res === 200) {
      message.open({
        key: "cancel",
        content: (
          <div className="flex items-center justify-center bg-[#171725E5]">
            <div className="text-white mr-2">{"Appointment canceled!"}</div>
          </div>
        ),
        duration: 5,
      });
      closePopup();
      const jwtToken = getLocalStorage(JWT_TOKEN);
      navigate(`/appointment-booking?jwtToken=${jwtToken}`);

      if (location.pathname.includes("/appointment-booking")) {
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
      trackEvent("AA_Cancel_Apt", {
        "Login Mobile No": appointmentDetails?.pm_contact_no,
        "Clinic Id": appointmentDetails?.hm_id,
        "Clinic Name": appointmentDetails?.hospital_name,
        "Time Stamp": dayjs().format("YYYY-MM-DD HH:mm:ss"),
        "Owner Doctor Name": appointmentDetails?.um_name,
        "Owner Doctor Unique ID": appointmentDetails?.um_id,
        "Patient Name": appointmentDetails?.pm_first_name,
        "Patient Id": appointmentDetails?.pam_pid,
        "Patient Age": calculateAge(appointmentDetails?.pm_dob)?.years,
        "Patient Gender": appointmentDetails?.pm_gender,
        page: location.pathname.includes("/appointment-booking")
          ? "home-appointment-page"
          : "success-appointment-page",
      });
    }
  };
  return (
    <Drawer
      placement="bottom"
      onClose={closePopup}
      closeIcon={false}
      open={show}
      height="auto"
      className="rounded-t-2xl overflow-hidden max-w-[450px] mx-auto"
      push={false}
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center">
          <div className="font-semibold text-lg">
            Are you sure you want to cancel an appointment?
          </div>
          <img src={close} alt="close" onClick={closePopup} />
        </div>
      </div>
      <section className="flex justify-center gap-5 mt-6 w-full text-base font-medium tracking-normal leading-loose text-center">
        <button
          className={`overflow-hidden gap-2 self-stretch px-14 py-2 text-indigo-600 bg-white whitespace-nowrap rounded-xl border border-indigo-600 border-solid flex justify-center`}
          aria-label={"cancel"}
          onClick={handleCancelAppointment}
        >
          Yes
        </button>
        <button
          className={`overflow-hidden gap-2 self-stretch px-14 py-2 text-white bg-indigo-600 whitespace-nowrap rounded-xl border border-indigo-600 border-solid flex justify-center`}
          aria-label={"logout"}
          onClick={closePopup}
        >
          No
        </button>
      </section>
    </Drawer>
  );
};

export default CancelConfirmation;
